import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AkitaNgRouterStoreModule } from '@datorama/akita-ng-router-store';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { CostElementsModule } from './cost-elements/cost-elements.module';
import { CustomPropertiesModule } from './custom-properties/custom-properties.module';
import { ProjectsModule } from './projects/projects.module';
import { SettingsModule } from './settings/settings.module';
import { SigninModule } from './signin/signin.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    environment.production ? [] : AkitaNgDevtools.forRoot(),
    AkitaNgRouterStoreModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CoreModule,
    ProjectsModule,
    CustomPropertiesModule,
    CostElementsModule,
    SigninModule,
    SettingsModule
  ],
  exports: [
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
